import { render, staticRenderFns } from "./HomeTabs.vue?vue&type=template&id=6b566eec&"
import script from "./HomeTabs.vue?vue&type=script&lang=ts&"
export * from "./HomeTabs.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTabs.vue?vue&type=style&index=0&id=6b566eec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports